export const postberbeno =
    [
        {
            id: "1", ime: "Не релевантно: Нема пост бербени манипулирања или складирање"
        },
        {
            id: "2", ime: "Не релевантно: Погледај посебен извештај за преработка"
        }
    ]